import React from "react";
import {Link} from "react-router-dom";
import {CircleHelp, SquareUserRound} from "lucide-react";
import {useJobSearch} from '@/context/JobSearchContext';

const Footer = () => {
  const {lastSearch} = useJobSearch();

  return (
      <div className="py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* --- Left Section --- */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-6">
              <span className="text-xl font-bold text-white">JobPool.ai</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              AI-powered job matching platform helping professionals find their ideal career opportunities with unparalleled precision and efficiency.
            </p>
            <div className="trust-badges flex items-center flex-wrap gap-8 text-gray-400 text-sm">
              {/* --- 256-bit Encryption Badge --- */}
              <div className="trust-badge flex items-center space-x-2">
                <svg fill="none" height="20" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                     strokeWidth="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                  <rect height="11" rx="2" ry="2" width="18" x="3" y="11"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                <span>256-bit Encryption</span>
              </div>

              {/* --- GDPR Compliant Badge --- */}
              <div className="trust-badge flex items-center space-x-2">
                <svg fill="none" height="20" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                     strokeWidth="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  <polyline points="9 12 11 14 15 10"></polyline>
                </svg>
                <span>GDPR and CCPA Compliant</span>
              </div>
            </div>
          </div>

          {/* --- Links Section --- */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">Links</h3>
            <ul className="space-y-4">
              {lastSearch?.exists === true ? (
                  <li>
                    <a
                        href="#job-results"
                        onClick={(e) => {
                          e.preventDefault();
                          const element = document.getElementById('job-results');
                          if (element) element.scrollIntoView({behavior: 'smooth'});
                        }}
                        className="text-gray-400 hover:text-white transition-colors">
                      Results
                    </a>
                  </li>
              ) : null}
              <li>
                <a href="#pricing"
                   onClick={(e) => {
                     e.preventDefault();
                     const element = document.getElementById('pricing');
                     if (element) element.scrollIntoView({behavior: 'smooth'});
                   }}
                   className="text-gray-400 hover:text-white transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#benefits"
                   onClick={(e) => {
                     e.preventDefault();
                     const element = document.getElementById('benefits');
                     if (element) element.scrollIntoView({behavior: 'smooth'});
                   }}
                   className="text-gray-400 hover:text-white transition-colors">
                  Benefits
                </a>
              </li>
              <li>
                <a href="#faq"
                   onClick={(e) => {
                     e.preventDefault();
                     const element = document.getElementById('faq');
                     if (element) element.scrollIntoView({behavior: 'smooth'});
                   }}
                   className="text-gray-400 hover:text-white transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* --- Get in Touch Section --- */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">Get in Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-center">
                <SquareUserRound className="w-5 h-5 text-blue-500 mr-3" />
                <a href="mailto:contact@jobpool.ai" className="text-gray-400 hover:text-white transition-colors">
                  contact@jobpool.ai
                </a>
              </li>
              <li className="flex items-center">
                <CircleHelp className="w-5 h-5 text-blue-500 mr-3" />
                <a href="mailto:support@jobpool.ai" className="text-gray-400 hover:text-white transition-colors">
                  support@jobpool.ai
                </a>
              </li>
              <li className="flex items-center">
                <img src="/discord.png" className="w-5 h-5 mr-3" alt="Discord logo" />
                <a href="https://discord.gg/3KCaxfTgNY" className="text-gray-400 hover:text-white transition-colors">
                  Discord
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* --- Footer Bottom --- */}
        <div className="mt-16 pt-8 pb-4 border-t border-gray-800 text-sm text-center text-gray-400">
          <p>© {new Date().getFullYear()} JobPool.ai. All rights reserved.</p>
          <p className="mt-2 text-gray-500">Images from Unsplash. Icons from Lucide.</p>
        </div>
      </div>
  );
};

export default Footer;